import { useState } from "react";
import { useData } from "@/hooks/useData";
import { StoneType } from "@/types/stone-type/stone-type.types";
import { useStoneTypeFilters } from "@/hooks/stone-types/useStoneTypeFilters";

export const useStoneTypeTable = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [showArchived, setShowArchived] = useState(false);
    const [nameFilters, setNameFilters] = useState<string[]>([]);

    const {
        data: stoneTypes,
        loading,
        refetch,
    } = useData<StoneType>({
        collectionName: "setup_stoneTypes",
    });

    const { filteredStoneTypes, getUniqueOptions } = useStoneTypeFilters({
        stoneTypes,
        searchTerm,
        showArchived,
        nameFilters,
    });

    const clearFilters = () => {
        setSearchTerm("");
        setNameFilters([]);
    };

    const nameOptions = getUniqueOptions("name");

    return {
        stoneTypes,
        filteredStoneTypes,
        loading,
        refetch,
        searchTerm,
        setSearchTerm,
        showArchived,
        setShowArchived,
        nameFilters,
        setNameFilters,
        clearFilters,
        nameOptions,
    };
}; 